import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { feedback } from '../api/methods';
/**
 * Feedback (v1 in-app feedback capture) React Query hooks.
 *
 * Cache shape:
 *   - feedbackKeys.list(status) -> FeedbackItem[] (manager/admin triage queue)
 *
 * Submission has no cached read on the submitting side (the field tech never
 * sees their own feedback list), so `useSubmitFeedback` is a plain mutation
 * with no cache to invalidate. Triage list mutations invalidate every cached
 * list variant so a status-filtered view and the "all" view both reconcile.
 */
export const feedbackKeys = {
    all: ['feedback'],
    lists: () => ['feedback', 'list'],
    list: (status) => ['feedback', 'list', status ?? 'all'],
};
/** Submit a bug/idea/question/other report (any authenticated member). */
export function useSubmitFeedback() {
    return useMutation({
        mutationFn: (data) => feedback.submit(data),
    });
}
/** Triage queue list, optionally filtered by status (manager/admin only). */
export function useFeedbackList(status) {
    return useQuery({
        queryKey: feedbackKeys.list(status),
        queryFn: () => feedback.list(status),
    });
}
/** Update status/triage_note/github_issue_number on a feedback row (manager/admin only). */
export function useUpdateFeedback() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }) => feedback.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: feedbackKeys.all });
        },
    });
}
//# sourceMappingURL=useFeedback.js.map